import React from 'react';

export default function Education() {
    return (
        <section id="education" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 pb-2 border-b-2 border-blue-500">
                EDUCATIONAL QUALIFICATION
            </h2>
            <div className="overflow-x-auto max-w-full">
                <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden text-sm md:text-base">
                    <thead className="bg-blue-100 text-blue-900">
                        <tr>
                            <th className="py-3 px-4 text-left">Degree</th>
                            <th className="py-3 px-4 text-left">University/Institute</th>
                            <th className="py-3 px-4 text-center">Year</th>
                            <th className="py-3 px-4 text-center">CGPA/Marks (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="border-b hover:bg-gray-100 transition duration-300">
                            <td className="py-3 px-4 font-medium">
                                M.Tech Computer Science & Engineering - TA
                            </td>
                            <td className="py-3 px-4">Indian Institute of Technology Hyderabad</td>
                            <td className="py-3 px-4 text-center">2025</td>
                            <td className="py-3 px-4 text-center">7.47</td>
                        </tr>
                        <tr className="border-b bg-gray-50 hover:bg-gray-100 transition duration-300">
                            <td className="py-3 px-4 font-medium">
                                B.Tech Computer Science & Engineering
                            </td>
                            <td className="py-3 px-4">CMR University, Bengaluru</td>
                            <td className="py-3 px-4 text-center">2023</td>
                            <td className="py-3 px-4 text-center">8.02</td>
                        </tr>
                        <tr className="border-b hover:bg-gray-100 transition duration-300">
                            <td className="py-3 px-4 font-medium">XII (AISSCE, CBSE)</td>
                            <td className="py-3 px-4">Tinsukia English Academy</td>
                            <td className="py-3 px-4 text-center">2019</td>
                            <td className="py-3 px-4 text-center">61.60%</td>
                        </tr>
                        <tr className="bg-gray-50 hover:bg-gray-100 transition duration-300">
                            <td className="py-3 px-4 font-medium">X (AISSE, CBSE)</td>
                            <td className="py-3 px-4">Tinsukia English Academy</td>
                            <td className="py-3 px-4 text-center">2017</td>
                            <td className="py-3 px-4 text-center">8.00</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    );
}
